import { render, staticRenderFns } from "./LeadTrendChart.vue?vue&type=template&id=6165efc5"
import script from "./LeadTrendChart.vue?vue&type=script&lang=js"
export * from "./LeadTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports